<rpshared-save-bar
	[title]="title$ | async"
	[isSaving]="isSaving$ | async"
	(save)="save($event)"
></rpshared-save-bar>

<div class="toolbar-margin"></div>

<div [formGroup]="form" fxLayout="column" fxLayoutGap="8px">
	<div fxLayout.gt-md="row" fxLayout.lt-lg="column" fxLayoutGap="8px">
		<div fxFlex.gt-md="65%" fxLayout="column" fxLayoutGap="8px">
			<rpshared-mat-loading-card
				[isLoading]="isLoading$ | async"
				icon="train"
				title="General Information"
			>
				<rpfsa-quote-general-info
					formControlName="generalInfo"
				></rpfsa-quote-general-info>
			</rpshared-mat-loading-card>

			<mat-card fxFlex *ngIf="!(isNonBillableJob$ | async)">
				<mat-progress-bar
					mode="indeterminate"
					class="mat-card-loading"
					*ngIf="isLoading$ | async"
				></mat-progress-bar>
				<rpshared-card-title
					icon="contact_phone"
					title="Billing Details"
				></rpshared-card-title>
				<rpshared-billing-details
					[railroad]="railroad$ | async"
					[customer]="customer$ | async"
					formControlName="billingDetails"
				></rpshared-billing-details>
			</mat-card>
		</div>

		<div fxFlex.gt-md="35%" fxLayout="column" fxLayoutGap="8px">
			<rpshared-mat-loading-card icon="history" title="Quote History">
				<div fxLayout="column">
					<mat-form-field fxFlex="100%">
						<textarea
							(keydown.enter)="sendNote($event)"
							[formControl]="note"
							matInput
							placeholder="Your message here"
						></textarea>
						<mat-error>Note cannot be blank.</mat-error>
					</mat-form-field>
					<rpshared-quote-log-table
						[isLoading]="isLoading$ | async"
						[listMessage]="quoteLogListMessage$ | async"
						[quoteLogs]="quoteLogs$ | async"
					></rpshared-quote-log-table>
				</div>
				<div fxLayout fxLayoutGap="10px" fxLayoutAlign="end">
					<div
						matTooltip="Quote Reports disabled for non-flagging services"
						[matTooltipDisabled]="canPrintQuoteReport$ | async"
					>
						<button
							mat-raised-button
							color="accent"
							(click)="printQuoteReport()"
							[disabled]="!(canPrintQuoteReport$ | async)"
							[class.shakeit]="shakeQuoteReport$ | async"
						>
							Print Quote Report
						</button>
					</div>
					<button
						(click)="approveQuote()"
						mat-raised-button
						[disabled]="!(canApprove$ | async)"
						[class.shakeit]="shakeApprove$ | async"
						color="primary"
					>
						Approve Quote
					</button>
				</div>
			</rpshared-mat-loading-card>

			<mat-card fxFlex>
				<mat-progress-bar
					mode="indeterminate"
					class="mat-card-loading"
					*ngIf="isLoading$ | async"
				></mat-progress-bar>
				<rpshared-card-title icon="add_location" title="Job Location">
				</rpshared-card-title>
				<rpshared-job-location
					[subdivisions]="subdivisionChoices$ | async"
					formControlName="jobLocation"
				></rpshared-job-location>
			</mat-card>
		</div>
	</div>

	<div fxLayout.gt-md="row" fxLayout.lt-lg="column" fxLayoutGap="8px">
		<mat-card fxFlex>
			<mat-progress-bar
				mode="indeterminate"
				class="mat-card-loading"
				*ngIf="isLoading$ | async"
			></mat-progress-bar>
			<rpshared-card-title icon="attach_money" title="Contracted Rates">
				<mat-slide-toggle
					[formControl]="prevailingWageToggle"
					(change)="prevailingWageToggled($event.checked)"
					labelPosition="before"
					>Prevailing Wage Applies</mat-slide-toggle
				>
			</rpshared-card-title>
			<rpshared-contract-rates-list
				*ngIf="hasMultipleServices$ | async; else singleRate"
				formControlName="contractedRates"
				[canMakeChanges]="true"
				[railroadRegularTimeBasis]="
					(railroad$ | async)?.regularTimeBasis
				"
				[isApplyPrevailingWage]="applyPrevailingWage$ | async"
				[isRequiredcertifiedPayrollFee]="true"
			></rpshared-contract-rates-list>
			<ng-template #singleRate>
				<rpshared-contract-rates-as-single-item-array
					formControlName="contractedRates"
					[isTurnOnPayrollFeeWeekly]="applyPrevailingWage$ | async"
					[regularTimeBasis]="(railroad$ | async)?.regularTimeBasis"
				>
				</rpshared-contract-rates-as-single-item-array>
			</ng-template>
		</mat-card>

		<mat-card fxFlex.gt-md="35%">
			<mat-progress-bar
				mode="indeterminate"
				class="mat-card-loading"
				*ngIf="isLoading$ | async"
			></mat-progress-bar>
			<rpshared-card-title
				icon="attach_money"
				title="Purchase Order Details"
			></rpshared-card-title>
			<rpfsa-purchase-order-details
				formControlName="purchaseOrderDetails"
			></rpfsa-purchase-order-details>
		</mat-card>
	</div>

	<rpshared-mat-loading-card
		[isLoading]="isLoading$ | async"
		icon="file_copy"
		title="Documents"
	>
		<div *ngIf="isNewRecord$ | async; else documentList">
			<span>Documents cannot be added until the quote is saved.</span>
		</div>
		<ng-template #documentList>
			<rpshared-document-list
				[parentId]="id$ | async"
				target="Job"
				formControlName="documents"
			></rpshared-document-list>
		</ng-template>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		[isLoading]="isLoading$ | async"
		icon="contact_phone"
		title="Field Contacts"
	>
		<rpshared-contact-list
			[showRequiredError]="showRequiredError$ | async"
			[emailRequired]="false"
			formControlName="fieldContacts"
		></rpshared-contact-list>
	</rpshared-mat-loading-card>

	<mat-card fxFlex *ngIf="hasOptionalFields$ | async">
		<mat-progress-bar
			mode="indeterminate"
			class="mat-card-loading"
			*ngIf="isLoading$ | async"
		></mat-progress-bar>
		<rpshared-card-title
			icon="list_alt"
			title="Additional Details"
		></rpshared-card-title>
		<rpfsa-optional-job-fields
			[fieldsToShow]="optionalJobFields$ | async"
			formControlName="optionalJobFields"
		></rpfsa-optional-job-fields>
	</mat-card>

	<div fxLayout.gt-md="row" fxLayout.lt-lg="column" fxLayoutGap="8px">
		<mat-card fxFlex *ngIf="prevailingWageToggle.value" [@slideInSlideOut]>
			<mat-progress-bar
				mode="indeterminate"
				class="mat-card-loading"
				*ngIf="isLoading$ | async"
			></mat-progress-bar>
			<rpshared-card-title icon="local_atm" title="Prevailing Wage Info">
				<div
					*ngIf="
						prevailingWageConfirmation$ | async as confirmation;
						else confirmationDetails
					"
				>
					<small>
						Confirmed By
						<strong>{{ confirmation.confirmedBy }}</strong> on
						<strong>{{
							confirmation.confirmedDate | date: 'shortDate'
						}}</strong>
					</small>
				</div>
				<ng-template #confirmationDetails>
					<button
						rpsharedConfirm="Confirm Prevailing Wage?"
						mat-button
						color="primary"
						(onConfirmed)="confirmPrevailingWage()"
					>
						Confirm Prevailing Wage
					</button>
				</ng-template>
			</rpshared-card-title>
			<rpfsa-prevailing-wage-info
				formControlName="prevailingWageInfo"
			></rpfsa-prevailing-wage-info>
		</mat-card>

		<mat-card
			fxFlex.gt-md="35%"
			[@slideInSlideOut]
			*ngIf="prevailingWageToggle.value"
		>
			<mat-progress-bar
				mode="indeterminate"
				class="mat-card-loading"
				*ngIf="isLoading$ | async"
			></mat-progress-bar>
			<rpshared-card-title
				icon="attach_money"
				title="Prevailing Wage Rates"
			></rpshared-card-title>
			<rpfsa-prevailing-wage-rates
				formControlName="prevailingWageRates"
			></rpfsa-prevailing-wage-rates>
		</mat-card>
	</div>
</div>
